module.exports = __webpack_public_path__ + "img/app_8.e27bb7ec.jpg";